import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {AdminPanel} from "./components/AdminPanel";
import {LogoutAction} from "./pages/LogoutAction";
import {EditLinguisticValue} from "./pages/settings/EditLinguisticValue";
import {ListLinguisticValues} from "./pages/settings/ListLinguisticValues";
import {ImportLinguisticValues} from "./pages/settings/ImportLinguisticValues";
import {SettingsLanguage} from "./pages/settings/SettingsLanguage";
import {MyProfile} from "./pages/settings/MyProfile";
import {StatusPage} from "./pages/StatusPage";
import {CreateLinguisticValue} from "./pages/settings/CreateLinguisticValue";
import {MissingLinguisticValue} from "./pages/settings/MissingLinguisticValue";
import {UserList} from "./pages/user/UserList";
import {CreateUser} from "./pages/user/CreateUser";
import {EditUser} from "./pages/user/EditUser";
import {OrderList} from "./pages/order/OrderList";
import {ProductList} from "./pages/product/ProductList";
import {CategoryList} from "./pages/category/CategoryList";
import {EditCategory} from "./pages/category/EditCategory";
import {ProductImport} from "./pages/product/ProductImport";
import {StatusInfo} from "./pages/StatusInfo";
import {OrderDetails} from "./pages/order/OrderDetails";
import {ProductDetails} from "./pages/product/ProductDetails";
import {SnapshotHistory} from "./pages/product/SnapshotHistory";
import {EmptyStorages} from "./pages/home/EmptyStorages";
import {StatusInfoWeekly} from "./pages/home/StatusInfoWeekly";
import {StatusInfoDaily} from "./pages/home/StatusInfoDaily";
import {StatusInfoAll} from "./pages/home/StatusInfoAll";
import {StatusInfoSession} from "./pages/home/StatusInfoSession";
import {User} from "./components/User";
import {ReceiptList} from "./pages/receipt/ReceiptList";
import {ReceiptDetails} from "./pages/receipt/ReceiptDetails";
import {ProductHistory} from "./pages/product/ProductHistory";
import {ShipmentList} from "./pages/shipment/ShipmentList";
import {ShipmentDetails} from "./pages/shipment/ShipmentDetails";
import {TransferProductList} from "./pages/transfer/TransferProductList";
import {TransferProductDetails} from "./pages/transfer/TransferProductDetails";
import {DamagedStorage} from "./pages/home/DamagedStorage";
import {DamagedProducts} from "./pages/product/DamagedProducts";
import {SubscriptionInfo} from "./pages/home/SubscriptionInfo";
import {SnapshotCompare} from "./pages/product/SnapshotCompare";
import {OrderScheduleList} from "./pages/order-schedule/OrderScheduleList";
import {OrderScheduleDetails} from "./pages/order-schedule/OrderScheduleDetails";
import {MissingProducts} from "./pages/product/MissingProducts";
import {MissingStorage} from "./pages/home/MissingStorage";
import {WarehouseValue} from "./pages/report/WarehouseValue";
import {MainPage} from "./pages/home/MainPage";
import {DailyPerformance} from "./pages/report/DailyPerformance";
import {InventoryList} from "./pages/inventory/InventoryList";
import {InventoryStart} from "./pages/inventory/InventoryStart";

export class Router extends React.Component<any, any> {
    protected user: User = new User();

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<AdminPanel/>}>

                        <Route index element={<StatusInfoSession/>}/>
                        <Route path="/info/all" element={<StatusInfoAll/>}/>
                        <Route path="/info/daily" element={<StatusInfoDaily/>}/>
                        <Route path="/info/session" element={<StatusInfoSession/>}/>
                        <Route path="/info/weekly" element={<StatusInfoWeekly/>}/>
                        <Route path="/info/status" element={<StatusInfo/>}/>
                        <Route path="/storage/empty-storages" element={<EmptyStorages/>}/>
                        <Route path="/storage/damaged-storage" element={<DamagedStorage/>}/>
                        <Route path="/storage/missing-storage" element={<MissingStorage/>}/>
                        <Route path="/subscription/info" element={<SubscriptionInfo/>}/>

                        <Route path="/user/list" element={<UserList/>}/>
                        <Route path="/user/create" element={<CreateUser/>}/>
                        <Route path="/user/edit/:id" element={<EditUser/>}/>

                        <Route path="/order/list" element={<OrderList/>}/>
                        <Route path="/order/details/:id" element={<OrderDetails/>}/>


                        <Route path="/report/warehouse-value" element={<WarehouseValue/>}/>
                        <Route path="/report/daily-performance" element={<DailyPerformance/>}/>

                        <Route path="/order-schedule/list" element={<OrderScheduleList/>}/>
                        <Route path="/order-schedule/details/:id" element={<OrderScheduleDetails/>}/>
                        {/*<Route path="/order-schedule/create" element={<OrderScheduleCreate/>}/>*/}
                        {/*<Route path="/order-schedule/edit/:id" element={<OrderScheduleEdit/>}/>*/}

                        <Route path="/inventory/list" element={<InventoryList/>}/>
                        <Route path="/inventory/exec" element={<InventoryStart/>}/>


                        <Route path="/receipt/list" element={<ReceiptList/>}/>
                        <Route path="/receipt/details/:id" element={<ReceiptDetails/>}/>

                        <Route path="/shipment/list" element={<ShipmentList/>}/>
                        <Route path="/shipment/details/:id" element={<ShipmentDetails/>}/>

                        <Route path="/transfer-product/list" element={<TransferProductList/>}/>
                        <Route path="/transfer-product/details/:id" element={<TransferProductDetails/>}/>

                        <Route path="/product/list" element={<ProductList/>}/>
                        <Route path="/product/import" element={<ProductImport/>}/>
                        <Route path="/product/details/:id" element={<ProductDetails/>}/>
                        <Route path="/product/history" element={<ProductHistory/>}/>
                        <Route path="/product/snapshot-history" element={<SnapshotHistory/>}/>
                        <Route path="/product/snapshot-compare" element={<SnapshotCompare/>}/>
                        <Route path="/product/damaged" element={<DamagedProducts/>}/>
                        <Route path="/product/missing" element={<MissingProducts/>}/>

                        <Route path="/product-category/list" element={<CategoryList/>}/>
                        {/*<Route path="/product-category/create" element={<CreateCategory/>}/>*/}
                        <Route path="/product-category/edit/:id" element={<EditCategory/>}/>

                        {/*<Route path="/client/list" element={<ClientList/>}/>*/}
                        {/*<Route path="/client/create" element={<CreateClient/>}/>*/}
                        {/*<Route path="/client/edit/:id" element={<EditClient/>}/>*/}

                        <Route path="/settings/index" element={<SettingsLanguage/>}/>
                        <Route path="/linguistic-values/list" element={<ListLinguisticValues/>}/>
                        <Route path="/linguistic-values/create" element={<CreateLinguisticValue/>}/>
                        <Route path="/linguistic-values/import" element={<ImportLinguisticValues/>}/>
                        <Route path="/settings/my-profile" element={<MyProfile/>}/>
                        <Route path="/linguistic-values/missing" element={<MissingLinguisticValue/>}/>
                        <Route path="/linguistic-values/edit/:namespace/:key" element={<EditLinguisticValue/>}/>

                        <Route path="/logout" element={<LogoutAction/>}/>
                        <Route path="*" element={<StatusPage code="404" message="page-not-found"/>}/>
                    </Route>

                    <Route path="/stats/all" element={<MainPage/>}/>
                    <Route path="/stats/yearly/:year" element={<MainPage/>}/>
                    <Route path="/stats/weekly/:year/:week" element={<MainPage/>}/>
                    <Route path="/stats/monthly/:year/:month" element={<MainPage/>}/>
                    <Route path="/stats/halfYearly/:year/:halfYear" element={<MainPage/>}/>
                    <Route path="/stats/daily/:year/:day" element={<MainPage/>}/>

                </Routes>
            </BrowserRouter>
        );
    };

    temp() {/*
        return (
            <>
                <Route path="/order/list" element={<OrderList/>}/>
                <Route path="/order/import" element={<ImportOrder/>}/>
                <Route path="/order/prepare" element={<PrepareOrder/>}/>
                <Route path="/order/pack" element={<PackOrder/>}/>
                <Route path="/order/tracking" element={<TrackingOrder/>}/>
                <Route path="/order/edit" element={<FormView/>}/>
                <Route path="/product/list" element={<ProductList/>}/>
                <Route path="/product/create" element={<FormView/>}/>
                <Route path="/product/edit" element={<FormView/>}/>
                <Route path="/product/import" element={<ImportProduct/>}/>
                <Route path="/product-bundle/list" element={<ProductBundleList/>}/>
                <Route path="/product-bundle/create" element={<FormView/>}/>
                <Route path="/product-bundle/import" element={<ImportProductBundle/>}/>
                <Route path="/transfer/list" element={<TransferList/>}/>
                <Route path="/transfer-in/create" element={<FormView/>}/>
                <Route path="/transfer-in/edit" element={<FormView/>}/>
                <Route path="/transfer-in/import" element={<ImportTransferIn/>}/>
                <Route path="/transfer-out/create" element={<FormView/>}/>
                <Route path="/transfer-out/edit" element={<FormView/>}/>
                <Route path="/transfer-out/import" element={<ImportTransferOut/>}/>
                <Route path="/transfer/capacity-planning" element={<FormView/>}/>
                <Route path="/client/list" element={<ClientList/>}/>
                <Route path="/client/create" element={<FormView/>}/>
                <Route path="/client/edit" element={<FormView/>}/>
                <Route path="/warehouse/list" element={<WarehouseList/>}/>
                <Route path="/warehouse/create" element={<FormView/>}/>
                <Route path="/warehouse/edit" element={<FormView/>}/>
                <Route path="/storage/list" element={<StorageList/>}/>
                <Route path="/storage/create" element={<FormView/>}/>
                <Route path="/storage/edit" element={<FormView/>}/>
                <Route path="/location/list" element={<LocationList/>}/>
                <Route path="/location/create" element={<FormView/>}/>
                <Route path="/location/edit" element={<FormView/>}/>
                <Route path="/inventory/list" element={<InventoryList/>}/>
                <Route path="/store/list" element={<StoreList/>}/>
                <Route path="/store/create" element={<FormView/>}/>
                <Route path="/store/edit" element={<FormView/>}/>
            </>
        );*/
    };
}
